//Webpack 4 is coupled to sockjs 😞
import SockJS from 'sockjs-client';

const socketUrlRegex = /\/sockjs-node(\/)?$/;

enum HmrEvents {
	Invalid = 'invalid',
	Hash = 'hash',
	Ok = 'ok',
	StillOk = 'still-ok',
	Errors = 'errors',
	Warnings = 'warnings',
	ContentChanged = 'content-changed',
	Hot = 'hot',
	LogLevel = 'log-level',
}

export class HmrSocket {
	private _socket: WebSocket;
	currentHash?: string;

	constructor(url: string) {
		const socketUrl = socketUrlRegex.test(url) ? url : url + '/sockjs-node';

		this._socket = new SockJS(socketUrl);
		this._socket.onmessage = this.handleMessage;
		this._socket.onclose = this.handleClose;
	}

	destroy() {
		this._socket.close();
	}

	public onStartPacking?: () => void;
	public onDidPack?: () => void;
	public onProblem?: () => void;

	private handleClose = (e: CloseEvent) => {
		this.onProblem && this.onProblem();
	};

	private handleMessage = (e: MessageEvent) => {
		if (!e || !e.data) return;

		console.debug('[HMR]', e.data);

		let parsed: MessageEvent;

		try {
			parsed = JSON.parse(e.data);
		} catch (err) {
			return;
		}

		this.handleMessageCases(parsed);
	};

	handleMessageCases = ({ type, data }: MessageEvent) => {
		switch (type) {
			case HmrEvents.Invalid:
				if (this.onStartPacking) this.onStartPacking();
				return;

			case HmrEvents.Hash:
				this.currentHash = data;
				if (this.onDidPack) this.onDidPack();
				return;

			case HmrEvents.Ok:
				return; //webpack success

			case HmrEvents.Errors:
				return;

			case HmrEvents.Warnings:
				return;

			//? :
			case HmrEvents.StillOk:
			case HmrEvents.ContentChanged:
			case HmrEvents.Hot:
			case HmrEvents.LogLevel:
				return;
			default:
			// console.debug('uncovered', `"${type}"`);
		}
	};
}
